<ng-container
  *ngIf="{
    article: article$ | async,
    product: product$ | async,
    articles: articles$ | async,
    unitCode: unitCode$ | async,
    quantity: quantity$ | async,
    ecommerceQuantity: ecommerceQuantity$ | async,
    units: units$ | async,
    attributes: attributes$ | async,
    selectedAttributes: selectedAttributes$ | async,
    showMinimumOrderError: showMinimumOrderError$ | async,
    disableActionButtons: disableActionButtons$ | async,
    enableSecondaryArticleRowVariant: enableSecondaryArticleRowVariant$ | async,
    isUserLoggedIn: isUserLoggedIn$ | async,
    enableArticleDetailsSection: enableArticleDetailsSection$ | async,
    enableDisplayOfPrices: enableDisplayOfPrices$ | async,
    breakableFeeHint: breakableFeeHint$ | async,
    articlePrice: articlePrice$ | async,
    articleDetails: articleDetails$ | async,
    loadingPrice: loadingPrice$ | async,
    outOfStockOnWebshop: outOfStockOnWebshop$ | async,
  } as data"
>
  <div class="sku-picker p-7" *ngIf="data.product">
    <div class="mb-3">
      <div class="d-flex flex-wrap">
        <div
          *ngFor="let attribute of data.attributes || []"
          class="mb-2 w-100"
          [class.article-picker-attribute]="data.attributes?.length > 1"
        >
          <py-picker-attribute
            [loading]="!data.articles || !attribute.options"
            [articles]="data.articles"
            [selectedAttributes]="data.selectedAttributes"
            [attribute]="attribute"
            [resetable]="data.attributes?.length > 1"
            (resetValue)="reset()"
            (updateSelectedAttribute)="updateSelectedAttribute($event)"
          ></py-picker-attribute>
        </div>
      </div>

      <div *ngIf="data.article" class="d-flex flex-column">
        <form [formGroup]="prePrintedCountryForm" *ngIf="!!data.article.articlePrePrintedConfigurationWithCountry" class="mb-2">
          <span class="mb-1 d-block label">
            <i
              nz-icon
              nzType="tags"
              nzTheme="outline"
              container="body"
              [ngbTooltip]="'article.prePrintingAvailable_tooltip' | cxTranslate"
            ></i>
            {{ 'catalog.specialPrePrintingArticleLabel_heading' | cxTranslate }}
          </span>
          <py-dropdown
            [formControlName]="'configuration'"
            [options]="data.article.articlePrePrintedConfigurationWithCountry"
            [title]="'catalog.specialPrePrintingArticleLabel_heading' | cxTranslate"
            [resetable]="true"
            [resetLabel]="'common.resetDropdown_action' | cxTranslate"
            (resetValue)="prePrintedConfigurationControl.reset()"
          ></py-dropdown>
        </form>
        <form [formGroup]="quantityForm" class="d-flex">
          <div class="w-50 pr-1">
            <py-counter-input [formControlName]="'quantity'" [step]="quantityStep"></py-counter-input>
          </div>

          <py-dropdown
            *ngIf="data.units?.length > 0"
            class="w-50 pl-1"
            [formControlName]="'unitCode'"
            [options]="data.units"
            [title]="'product.unit_heading' | cxTranslate"
          ></py-dropdown>
        </form>

        <p class="text-danger mt-2" *ngIf="data.showMinimumOrderError">
          {{
            'catalog.minimumOrderQuantity_hint'
              | cxTranslate
                : {
                    quantity: data.article.minimumOrderQuantity,
                    unit: (data.article.unit | unit: data.article?.minimumOrderQuantity),
                  }
          }}
        </p>
      </div>
    </div>

    <div class="mb-3 hide-on-print pricing-wrapper" *ngIf="!!data.article || !!data.product?.articlePickerAttributes?.length">
      <ng-container *ngIf="data.enableDisplayOfPrices; else signInForPriceTemplate">
        <div
          class="d-flex flex-column mb-1 pt-1"
          [ngClass]="{
            'align-items-start': !data.enableSecondaryArticleRowVariant,
            'align-items-end': data.enableSecondaryArticleRowVariant,
          }"
        >
          <div class="pricing-details-wrapper d-flex align-items-end">
            <ng-container *ngIf="!!data.article; else noPriceTemplate">
              <py-article-price
                *ngIf="data.articlePrice?.formattedPrice && !data.loadingPrice"
                [articlePrice]="data.articlePrice"
                [showArticlePriceInsteadOfEntryPrice]="true"
                [horizontalAlignment]="
                  data.enableSecondaryArticleRowVariant ? horizontalAlignments.RIGHT : horizontalAlignments.LEFT
                "
                [priceCampaign]="data.article.priceCampaign"
              ></py-article-price>

              <ng-container *ngIf="data.loadingPrice" [ngTemplateOutlet]="loadingPriceTemplate"> </ng-container>

              <button
                class="btn btn-secondary mb-1 py-1 rounded-pill"
                (click)="loadPrice()"
                *ngIf="!data.articlePrice?.formattedPrice && !data.loadingPrice && data.articlePrice?.attempts === 5"
              >
                {{ 'catalog.getPrice_action' | cxTranslate }}
              </button>

              <p class="h4" *ngIf="!data.articlePrice?.formattedPrice && !data.loadingPrice && data.articlePrice?.attempts > 5">
                {{ 'catalog.priceNotAvailable_hint' | cxTranslate }}
              </p>
            </ng-container>
          </div>
          <p class="py-color-grey-500">
            {{ 'product.quantity_heading' | cxTranslate }}
            <span *ngIf="data.article && data.ecommerceQuantity; else noQuantityTemplate">
              {{ data.ecommerceQuantity | cxNumeric: '1.0-0' }} {{ data.article.unit | unit: data.ecommerceQuantity }}
            </span>
          </p>
        </div>
      </ng-container>
    </div>

    <ng-container *pyPrincipalConfiguration="'enableBreakableArticleExplanation'">
      <div class="my-3" *ngIf="data.article?.breakable && !!data.breakableFeeHint && data.breakableFeeHint !== ''">
        <p class="py-color-grey-500">
          <i class="mr-1 text-danger" nz-icon nzType="warning" nzTheme="fill"></i>
          {{ data.breakableFeeHint }}
        </p>
      </div></ng-container
    >

    <div class="d-flex no-gutters align-items-center justify-content-between" *pyScreenSize="{ min: 'lg' }; else mobileActions">
      <ng-container *ngTemplateOutlet="addToCartActionButton"></ng-container>

      <ng-container *ngTemplateOutlet="shoppingListActionButton"></ng-container>

      <ng-container *ngTemplateOutlet="orderCardActionButton"></ng-container>

      <ng-container *ngTemplateOutlet="areaOfUseActionButton"></ng-container>
    </div>

    <ng-template #mobileActions>
      <div class="d-flex flex-column">
        <ng-container *ngTemplateOutlet="addToCartActionButton"></ng-container>

        <ng-container
          *ngTemplateOutlet="shoppingListActionButton; context: { $implicit: { showButton: true, disableTooltip: true } }"
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="orderCardActionButton; context: { $implicit: { showButton: true, disableTooltip: true } }"
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="areaOfUseActionButton; context: { $implicit: { showButton: true, disableTooltip: true } }"
        ></ng-container>
      </div>
    </ng-template>

    <div *ngIf="showError" class="text-center mt-3">
      <i nz-icon nzType="exclamation-circle-o" class="text-danger mr-2"></i
      ><span class="submit-error">{{ 'product.selectAttributesToAddToCart_text' | cxTranslate }}</span>
    </div>

    <div class="mt-3 pt-3 additional-info hide-on-empty">
      <py-detailed-stock-info
        *ngIf="!!data.article"
        [article]="data.article"
        [quantity]="data.quantity"
        [unitCode]="data.unitCode"
        [enableSecondaryArticleRowVariant]="data.enableSecondaryArticleRowVariant"
        [enableArticleDetailsSection]="data.enableArticleDetailsSection"
        (articleOutOfStockChange)="emitArticleOutOfStockChange($event)"
      ></py-detailed-stock-info>
    </div>

    <div
      *ngIf="
        data.articleDetails?.eanCode ||
        showAListOfAllAvailableVariantsLink ||
        (data.article?.displayOldArticleNumber && data.article?.oldArticleNumber)
      "
      class="mt-3 pt-3 additional-info hide-on-empty"
    >
      <ng-container *ngIf="!data.enableArticleDetailsSection">
        <div *ngIf="data.articleDetails?.eanCode" class="ean">
          <i nz-icon nzType="barcode-o" class="mr-2"></i>
          <span>{{ 'catalog.eanCode_hint' | cxTranslate: { code: data.articleDetails.eanCode } }}</span>
        </div>
        <div class="article-code" *ngIf="data.article?.displayOldArticleNumber && data.article?.oldArticleNumber">
          {{ 'article.oldArticleNumber_hint' | cxTranslate: { articleNumber: data.article?.oldArticleNumber } }}
        </div>
      </ng-container>

      <div *ngIf="showAListOfAllAvailableVariantsLink">
        <button class="link text-left" id="sku-picker-open-variants-button" (click)="openModal()">
          <i nz-icon nzType="profile" class="mr-2"></i>
          {{ 'product.viewAllVariants_text' | cxTranslate }}
        </button>
      </div>
    </div>
  </div>

  <ng-template #shoppingListActionButton let-actionButtonData>
    <py-add-to-shopping-list
      *pyPrincipalConfiguration="'enableOrderTemplates'"
      [dark]="true"
      [articleCode]="data.article?.code"
      [quantity]="(quantityForm.get('quantity').valueChanges | async) || quantityForm.get('quantity').value"
      [unit]="activeUnit"
      [disabled]="data.disableActionButtons"
      [showButton]="actionButtonData?.showButton"
      [disableTooltip]="actionButtonData?.disableTooltip"
      [articleNumber]="shoppingListArticleNumber"
    ></py-add-to-shopping-list>
  </ng-template>

  <ng-template #orderCardActionButton let-actionButtonData>
    <py-add-to-order-card
      *pyPrincipalConfiguration="'enableOrderCardsAdmin'"
      [productCode]="data.product.code"
      [showButton]="actionButtonData?.showButton"
      [disabled]="data.outOfStockOnWebshop"
      [disableTooltip]="actionButtonData?.disableTooltip"
    ></py-add-to-order-card>
  </ng-template>

  <ng-template #areaOfUseActionButton let-actionButtonData>
    <py-add-to-area-of-use
      *pyPrincipalConfiguration="'enableCustomerEditingOfAreaOfUseAdmin'"
      [productCode]="data.product.code"
      [showButton]="actionButtonData?.showButton"
      [disableTooltip]="actionButtonData?.disableTooltip"
    ></py-add-to-area-of-use>
  </ng-template>

  <ng-template #addToCartActionButton let-actionButtonData>
    <button
      class="btn btn-primary btn-block add-to-cart-button"
      (click)="addToCart()"
      [disabled]="data.disableActionButtons"
      [class]="actionButtonData?.class"
    >
      <i nz-icon nzType="shopping-cart"></i>
      {{ 'product.addToCart_action' | cxTranslate }}
    </button>
  </ng-template>

  <ng-template #loadingPriceTemplate>
    <span class="spinner-section d-block">
      <cx-spinner [type]="'dark'"></cx-spinner>
    </span>
  </ng-template>

  <ng-template #signInForPriceTemplate>
    <button
      *ngIf="!data.isUserLoggedIn && data.product?.articles?.length !== 1 && data.product?.articlePickerAttributes?.length"
      class="link sign-in-button mb-1 mt-3"
      (click)="login()"
    >
      {{ 'product.signInForPrice_action' | cxTranslate }}
      <i class="ml-2" nz-icon nzType="arrow-right"></i>
    </button>
  </ng-template>

  <ng-template #noQuantityTemplate>{{ 'product.noQuantity_hint' | cxTranslate }}</ng-template>

  <ng-template #noPriceTemplate>
    <p class="h4">{{ 'catalog.priceNotAvailableWithCurrency_hint' | cxTranslate: { currency: activeCurrency$ | async } }}</p>
  </ng-template>
</ng-container>
